import styles from './Architecture.module.scss'

interface Props {
  contents: {
    title: string
    imgLink: string[]
  }
}

const Architecture: React.FC<Props> = ({ contents }) => {
  const listItems = contents.imgLink.map((item, i) => <img key={i} src={item} alt={item} />)

  return (
    <div className={styles.section}>
      <div className={styles.wrapper}>
        <div className={styles.section_heading}>
          <span>{contents.title}</span>の基本的なアーキテクチャ図
        </div>
      </div>
      <div className={styles.image_wrapper}>{listItems}</div>
    </div>
  )
}
export default Architecture
